<div class="expression-editor-layout">
  <!-- Menu Component -->
  <expressions-editor-menu
    #menuComponent
    class="layout-menu-container"
    [editorInitialValue]="editorInitialValue"
    [editorContent]="oPathEditor?.textContent ?? ''"
    [columnTitle]="columnTitle"
    [height]="UiSettings.menuHeight"
    [redoHistory]="history.redo"
    [undoHistory]="history.undo"
    (onMenuButtonClick)="handleMenuButtonClick($event)"
    [neutralDesignationActive]="neutralDesignationActive"
  >
  </expressions-editor-menu>

  <!-- Navigation Component -->
  <expressions-editor-navigation
    #navigation
    class="layout-nav-container"
    [ngStyle]="{ width: UiSettings.navigationWidth + 'px', top: UiSettings.menuHeight + 'px' }"
    (onNavigationChange)="loadNavigationComponent($event)"
  ></expressions-editor-navigation>

  <div
    #layoutContainer
    class="layout-content-container"
    [ngStyle]="{
      top: UiSettings.menuHeight + 'px',
      height: 'calc(100% - ' + UiSettings.menuHeight + 'px)',
      width: 'calc(100% - ' + UiSettings.navigationWidth + 'px)'
    }"
  >
    <div class="layout-editor-container" id="layout-editor-container" #layoutEditorContainer>
      <div
        class="columnTitle-container"
        [ngStyle]="{
          width: uiConfig.get(UiEnum.editorTitle).width() + 'px'
        }"
      >
        <abc-text-box
          #columnTitleTextBox
          class="columnTitleTextBox"
          [placeholder]="translation?.columnTitle"
          [value]="columnTitle.initialValue"
          [valueChangeEvent]="'keyup'"
          (onValueChanged)="setcolumnTitle($event)"
        ></abc-text-box>
      </div>

      <div
        class="editor-container"
        [ngStyle]="{
          width: uiConfig.get(UiEnum.editorContainer).width() + 'px'
        }"
      >
        <!-- Left Position Operators -->
        <ng-container *ngIf="getNavigation(ComponentNameEnum.OperatorLeftPosition)">
          <expressions-editor-operators
            #operatorsLeftPosition
            class="permanent-operators-container-left-position"
            id="operators-left-position"
            [height]="uiConfig.get(UiEnum.operator).height()"
            [width]="uiConfig.get(UiEnum.operator).width()"
            [position]="OperatorPosition.left"
            (onChangePosition)="changeOperatorsPosition($event)"
            (onOperatorSelected)="handleOperatortSelected($event)"
          ></expressions-editor-operators>
        </ng-container>

        <div style="height: 100%; display: flex; flex-direction: column">
          <abc-scroll-view #editorScrollView style="overflow: clip" (click)="focusEditor()">
            <section class="editorContainer">
              <div class="codeEditor">
                <div class="lineNumberContainer">
                  <div *ngFor="let lineNumber of lineNumbers; let i = index">{{ lineNumber }} <br /></div>
                </div>
                <code
                  #editor
                  class="editor"
                  contenteditable="true"
                  spellcheck="false"
                  [id]="editorInstancesettings.editorId"
                  [ngStyle]="{ width: uiConfig.get(UiEnum.editorBody).width() + 'px' }"
                  (keydown)="handleKeyboardChange($event)"
                  (input)="handleInput()"
                  (mouseup)="handleSelection()"
                  (paste)="onPaste($event)"
                ></code>
              </div>
            </section>
          </abc-scroll-view>

          <!-- Bottom Position Operators -->
          <ng-container *ngIf="getNavigation(ComponentNameEnum.OperatorBottomPosition)">
            <expressions-editor-operators
              [position]="OperatorPosition.bottom"
              (onChangePosition)="changeOperatorsPosition($event)"
              (onOperatorSelected)="handleOperatortSelected($event)"
            ></expressions-editor-operators>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="layout-navigation-container" id="layout-navigation-container" #navigationContainer>
      <!-- Entity Component -->
      <ng-container *ngIf="getNavigation(ComponentNameEnum.EntityComponent)">
        <abc-splitter
          #splitterEntity
          class="NavigationContent"
          orientation="left"
          [maxWidth]="splitter.get(SplitterEnum.entity).maxWidth()"
          [removeTransforms]="true"
        >
          <expressions-editor-entity
            [neutralDesignationActive]="neutralDesignationActive"
            [entityData]="objectTypeInfo"
            [pinned]="permanentNavigation[ComponentNameEnum.EntityComponent]"
            (onEntitySelected)="handleEntitySelection($event)"
            (onPinChange)="togglePermanentNavigation(ComponentNameEnum.EntityComponent)"
          ></expressions-editor-entity>
        </abc-splitter>
      </ng-container>

      <!-- Function Component -->
      <ng-container *ngIf="getNavigation(ComponentNameEnum.FunctionComponent)">
        <abc-splitter
          #splitterFunction
          class="NavigationContent"
          orientation="left"
          [maxWidth]="splitter.get(SplitterEnum.function).maxWidth()"
          [removeTransforms]="true"
        >
          <expressions-editor-function
            style="width: 100%"
            (ontoggleFunction)="togglePermanentNavigation(ComponentNameEnum.FunctionComponent)"
            (onOPathFunctionSelected)="handleFunctionSelected($event)"
          ></expressions-editor-function>
        </abc-splitter>
      </ng-container>

      <!-- Parameters Component -->
      <ng-container *ngIf="getNavigation(ComponentNameEnum.ParametersComponent)">
        <abc-splitter
          #splitterParameter
          class="NavigationContent"
          orientation="left"
          [maxWidth]="splitter.get(SplitterEnum.parameter).maxWidth()"
          [removeTransforms]="true"
        >
          <parameters-definitions-editor
            [editorInstancesettings]="editorInstancesettings"
            [(parameterDefinitions)]="parameterDefinitions"
            (onParameterRemoved)="highlightInvalidParameters($event)"
            (onParameterSelected)="handleParameterSelected($event)"
          ></parameters-definitions-editor>
        </abc-splitter>
      </ng-container>

      <!-- Search Component -->
      <ng-container *ngIf="getNavigation(ComponentNameEnum.SearchComponent)">
        <app-search
          style="order: 1"
          class="NavigationContent"
          fxFlex="200px"
          (onSearchParametre)="handleSearchParameter($event)"
          (onReplaceText)="handleRelaceParameter($event)"
          (onMatchText)="handleMatchText($event)"
          [searchOccurence]="searchOccurence"
          [matcheIndex]="matcheIndex"
          [isHighlightCleared]="false"
          [mouseTextSelected]="mouseTextSelected"
        >
        </app-search>
      </ng-container>

      <!-- Validate Component -->
      <ng-container *ngIf="getNavigation(ComponentNameEnum.ValidateComponent)">
        <expressions-editor-validate
          style="order: 1"
          class="NavigationContent"
          fxFlex="200px"
          (onStartOPathValidation)="startOPathValidation()"
        ></expressions-editor-validate>
      </ng-container>

      <!-- Operators Component -->
      <ng-container *ngIf="getNavigation(ComponentNameEnum.OperatorsComponent)">
        <expressions-editor-operators
          [position]="OperatorPosition.right"
          style="order: 1"
          class="NavigationContent"
          fxFlex="200px"
          (onChangePosition)="changeOperatorsPosition($event)"
          (onOperatorSelected)="handleOperatortSelected($event)"
        ></expressions-editor-operators>
      </ng-container>
    </div>
  </div>
</div>
